import {createContext, useContext, useState, useLayoutEffect} from 'react';
import {Skeleton} from 'antd';
import {useLocation, Location, useNavigate} from 'react-router';
import {set} from 'lodash';
import {QualifyInfo} from '@/types/api/qualify';
import {SCIndexContainer} from '@/styles/modules';
import client from '@/api/client';
import {qualifyInfo, redirect} from './redirect/redirect';
import {redirectChange} from './redirect/change';

// 无需鉴权的页面
function getEscapeRoute(pathname: string) {
    const actionName = pathname;
    const ESCAPE_KEY = [
        '/confirm', '/agreement',
        '/face/result', '/auth/iframe',
        'sdk', '/education',
        '/company/noBusiness/change',
    ];
    return ESCAPE_KEY.some(key => actionName.includes(key));
}

export function requiredAuthUrl(location: any) {
    const unAuthPathName = ['iam/qualify-h5.html', 'qualify/h5/'].some(cur => location.pathname.includes(cur));
    return !getEscapeRoute(location.pathname) && !unAuthPathName;
}

async function getAfterAction(info: QualifyInfo, location: Location) {
    const actionName = location.pathname.split('/qualify/').length > 1
        ? location.pathname.split('/qualify/')[1] : '';
    const needAuth = requiredAuthUrl(location);
    if (needAuth) {
        const params = location.search.split('?').length > 1 ? location.search.split('?')[1] : '';
        const res = await client.compChangeCheck();
        if (res?.disallowedChangeScenarios?.includes('原主体已注销或吊销')) {
            set(info, 'changeInfo.isNoBusiness', true);
        }
        const changeAfter = redirectChange(info, actionName, params);
        if (changeAfter) {
            return `/qualify/${changeAfter}`;
        }
        const infoAfter = redirect(info, actionName);
        if (infoAfter) {
            return `/qualify/${infoAfter}${location.search}`;
        }
    }
    return '';
}

export const InfoContext = createContext<QualifyInfo | undefined>(undefined);

export function useQualifyInfo() {
    const info = useContext(InfoContext);
    return info;
}

export const AuthGuard = (props: any) => {
    const [info, setInfo] = useState<QualifyInfo>();
    const location = useLocation();
    const navigate = useNavigate();

    useLayoutEffect(
        () => {
            qualifyInfo().then(async info => {
                const afterAction = info ? await getAfterAction(info, location) : '';
                setInfo(info);
                if (afterAction) {
                    return navigate(afterAction, {
                        replace: true,
                        state: {
                            redirect: true,
                        },
                    });
                }
            }, () => {
                setInfo(undefined);
            });
        },
        [location.pathname]
    );

    return (
        <InfoContext.Provider value={info}>
            {info ? props.children : <SCIndexContainer><Skeleton active /></SCIndexContainer>}
        </InfoContext.Provider>
    );
};
